module.exports = __webpack_public_path__ + "static/media/boot.0aa626a2.png";